export const POCKETBASE_URL = 'https://120478188.pb.erpsys.pro/';

/** Correo vía mailer de PocketBase (pb_hooks/picking.pb.js) */
export const POCKETBASE_MAIL = {
  welcomeRoute: '/api/picking/welcome-mail',
  welcomeSubjectEmoji: '👋',
};

const ERP_TENANT_ID = POCKETBASE_URL.match(/https:\/\/(\d+)\.pb\./)?.[1] || '120478188';

/** ERP REST API — productos lookup for picker */
export const ERP_API = {
  baseUrl: 'https://v1.erpsys.pro',
  token: 'erpsys_dev_a7f3c9e2b8d14f6051a9e3c7',
  settingFile: ERP_TENANT_ID,
  sucursalId: 1,
  usuarioId: 1,
  bodegaId: 1,
  productosPath: '/API/v1/files/get_productos.php',
};

export const BRAND = {
  name: 'PowerTech',
  logo: '/assets/images/logopower-sf1.png',
  tagline: 'Tu mejor herramienta.',
};

export const DASHBOARD_CONFIG = {
  displayStatuses: [
    'ESPERANDO_AUTORIZACION_CREDITOS',
    'AUTORIZADO_POR_CREDITOS',
    'RECHAZADO_POR_CREDITOS',
    'ASIGNACION_MESA',
    'LISTO_PARA_FACTURAR',
    'FACTURADO',
  ],
  /** Columnas del tablero para rol Mesa (picker) */
  pickerDisplayStatuses: [
    'AUTORIZADO_POR_CREDITOS',
    'ASIGNACION_MESA',
  ],
  statusLabels: {
    ESPERANDO_AUTORIZACION_CREDITOS: 'Esperando autorización de créditos',
    AUTORIZADO_POR_CREDITOS: 'Autorizado por créditos',
    RECHAZADO_POR_CREDITOS: 'Rechazado por Créditos',
    ASIGNACION_MESA: 'Asignación de mesa',
    LISTO_PARA_FACTURAR: 'Listo para facturar',
    FACTURADO: 'Facturado',
  },
  loadingTints: {
    ESPERANDO_AUTORIZACION_CREDITOS: 'from-amber-100 to-amber-50 border-amber-200',
    AUTORIZADO_POR_CREDITOS: 'from-teal-100 to-teal-50 border-teal-200',
    RECHAZADO_POR_CREDITOS: 'from-red-100 to-red-50 border-red-200',
    ASIGNACION_MESA: 'from-orange-100 to-orange-50 border-orange-200',
    LISTO_PARA_FACTURAR: 'from-emerald-100 to-emerald-50 border-emerald-200',
    FACTURADO: 'from-sky-100 to-sky-50 border-sky-200',
  },
  statusColors: {
    ESPERANDO_AUTORIZACION_CREDITOS: 'bg-amber-200 border-amber-300 text-amber-800',
    AUTORIZADO_POR_CREDITOS: 'bg-teal-200 border-teal-300 text-teal-700',
    RECHAZADO_POR_CREDITOS: 'bg-red-200 border-red-300 text-red-700',
    ASIGNACION_MESA: 'bg-orange-200 border-orange-300 text-orange-700',
    LISTO_PARA_FACTURAR: 'bg-emerald-200 border-emerald-300 text-emerald-800',
    FACTURADO: 'bg-sky-200 border-sky-300 text-sky-800',
    NOT_READY: 'bg-red-200 border-red-300 text-red-700',
    PACKING: 'bg-yellow-500 border-yellow-600 text-yellow-900',
    PARTIALLY_READY: 'bg-orange-200 border-orange-300 text-orange-700',
    READY: 'bg-teal-200 border-teal-300 text-teal-700',
    ON_ROUTE: 'bg-lightBlue-200 border-lightBlue-300 text-lightBlue-700',
    DELIVERED: 'bg-emerald-200 border-emerald-300 text-emerald-700',
    RETURNED: 'bg-red-200 border-red-300 text-red-700',
    DEFAULT: 'bg-gray-100 border-gray-300 text-gray-700',
  },
  /** Opaque hex colors — matches statusColors, used for side panels */
  statusPaneTheme: {
    ESPERANDO_AUTORIZACION_CREDITOS: { bg: '#fde68a', border: '#fcd34d', text: '#92400e' },
    AUTORIZADO_POR_CREDITOS: { bg: '#99f6e4', border: '#5eead4', text: '#0f766e' },
    RECHAZADO_POR_CREDITOS: { bg: '#fecaca', border: '#fca5a5', text: '#b91c1c' },
    ASIGNACION_MESA: { bg: '#fed7aa', border: '#fdba74', text: '#c2410c' },
    LISTO_PARA_FACTURAR: { bg: '#a7f3d0', border: '#6ee7b7', text: '#047857' },
    FACTURADO: { bg: '#bae6fd', border: '#7dd3fc', text: '#0369a1' },
    NOT_READY: { bg: '#fecaca', border: '#fca5a5', text: '#b91c1c' },
    PACKING: { bg: '#eab308', border: '#ca8a04', text: '#713f12' },
    PARTIALLY_READY: { bg: '#fed7aa', border: '#fdba74', text: '#c2410c' },
    READY: { bg: '#99f6e4', border: '#5eead4', text: '#0f766e' },
    ON_ROUTE: { bg: '#bae6fd', border: '#7dd3fc', text: '#0369a1' },
    DELIVERED: { bg: '#a7f3d0', border: '#6ee7b7', text: '#047857' },
    RETURNED: { bg: '#fecaca', border: '#fca5a5', text: '#b91c1c' },
    DEFAULT: { bg: '#f3f4f6', border: '#d1d5db', text: '#374151' },
  },
};

export function getStatusLabel(status) {
  return DASHBOARD_CONFIG.statusLabels[status] || status;
}

export function getStatusColorClasses(status) {
  return DASHBOARD_CONFIG.statusColors[status] || DASHBOARD_CONFIG.statusColors.DEFAULT;
}

/** Same palette as CardStatus columns — for opaque side panels */
export function getStatusPaneClasses(status) {
  return getStatusColorClasses(status);
}

export function getStatusPaneTheme(status) {
  return DASHBOARD_CONFIG.statusPaneTheme[status] || DASHBOARD_CONFIG.statusPaneTheme.DEFAULT;
}
